export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDVKdKB4ywFpJbgk0eitXVwG7YeSjwGCa4",
    authDomain: "chareety-dev-4.firebaseapp.com",
    projectId: "chareety-dev-4",
    storageBucket: "chareety-dev-4.firebasestorage.app",
    messagingSenderId: "768587471920",
    appId: "1:768587471920:web:8497262633007f0f9fa1f5",
    measurementId: "G-061S2PCY0Z"
  },
  // Test Publishable Key for local development & testing
  stripeKey: "pk_test_51LsogEEQkKnpYqBZiG4X70WG2WnI94TzKZNrBWLfTU0o5hrFpPZEUOf39VioWABFeB0Y8nD6YZd6pEH9aVsbp60X005oYTEVbS",
  // App Check debug token — patched by register-app.js
  appCheckDebugToken: "879c01d8-7f5b-49ed-a067-d60ec2907b4e",
  // reCAPTCHA site key — patched by register-app.js
  recaptchaSiteKey: "6LebiYktAAAAAOfRGdlBfX4AYBv8nhEnkniuUAKz",
  // Google Maps API key for address autocomplete
  googleMapsApiKey: "AIzaSyCrWUmhRHanIE1rUnwYKoGdG8wk9fHbXcE",
  // App domain for subdomain preview
  appDomain: "dev.chareety.com",
  // App URLs (environment-specific)
  appUrls: {
    orgConsole: "https://console-dev.chareety.com",
    partners: "https://partners-dev.chareety.com",
    myChareety: "https://my-dev.chareety.com",
    marketing: "https://dev.chareety.com",
  },
};
